import { render, staticRenderFns } from "./noRemove.vue?vue&type=template&id=01f24cca"
import script from "./noRemove.vue?vue&type=script&lang=ts"
export * from "./noRemove.vue?vue&type=script&lang=ts"
import style0 from "./noRemove.vue?vue&type=style&index=0&id=01f24cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports